module.exports = __webpack_public_path__ + "static/media/dpd.182340bb.png";